import React, { useEffect, useState } from 'react';
import { getTableauDashboardLinksByUserId } from '../../services/api/tableauDashboardLinks';
import { useDispatch, useSelector } from "react-redux";
import { raiseToast } from "../../services/redux/reducers/toast/toast";


const TableauDashboard = () => {
    const userDetails = useSelector((state) => state.userDetails)
    const userId = userDetails?.userId
    const [tableauLinks, setTableauLinks] = useState({});

    const dispatch = useDispatch()

    useEffect(() => {  
        fetchTableauLinks()
    }, [])

    useEffect(() => {
        if(tableauLinks?.dashboardLinks){ 
            constructTableauViz()
        }
    }, [tableauLinks])

    const fetchTableauLinks = async () => {
        const dashboardLinks = await getTableauDashboardLinksByUserId(userId)

        if(dashboardLinks?.failure){
            return dispatch(raiseToast({severity:'error', detail:dashboardLinks?.data?.error , life: 3000}))
        }
        else{
            const fetchedTableauLinks = dashboardLinks?.data?.dashboardLinks

            if (fetchedTableauLinks && Object.keys(fetchedTableauLinks).length > 0) {
                setTableauLinks({dashboardLinks: fetchedTableauLinks, showDashboardToolbar: dashboardLinks?.data?.showDashboardToolbar, dashboardFilters: dashboardLinks?.data?.dashboardFilters});
            } else {
                const pmBranchId = userDetails?.activeUserRoleDetails?.branchId;
                const pmBranches = userDetails?.PMCompanyDetails?.companyPmBranches;

                const relatedPmBranch = pmBranches?.find(each => each.branchId === pmBranchId);

                if (relatedPmBranch && relatedPmBranch.dashboardLinks) {
                    setTableauLinks({dashboardLinks: relatedPmBranch.dashboardLinks, showDashboardToolbar: relatedPmBranch.showDashboardToolbar, dashboardFilters: relatedPmBranch.dashboardFilters});
                } else {
                    setTableauLinks({})
                    return dispatch(raiseToast({severity:'warn', detail: "No dashboard links found!", life: 3000}))
                }
            }
        }
    }

    const constructTableauViz = () => {
        const tableauApplicationContainer = document.getElementById('tableau-application');
        
        //tableauApplicationContainer.style.width = '80%';
        tableauApplicationContainer.style.margin = 'auto';

        Object.entries(tableauLinks?.dashboardLinks).forEach(([key, value]) => {
            const indvTableauContainer = document.createElement("div");
            indvTableauContainer.setAttribute('id', key);
            
            const heading = document.createElement("h2");
            heading.textContent = "PROCMART DASHBOARD";
            heading.style.color = "white";
            heading.style.marginBottom = "15px";
            heading.style.marginTop = "4px";
            heading.style.fontSize = "27px";
            indvTableauContainer.appendChild(heading);
    
            const tableauStyleContainer = document.createElement("div");
            tableauStyleContainer.style.height = '100px';
    
            const vizUrl = value;

            let hideToolbar = true
            if(tableauLinks?.showDashboardToolbar){
                hideToolbar = false
            }
    
            let options = {
                width: '1313px',
                height: '770px',
                hideTabs: true,
                hideToolbar: hideToolbar,
                //"Procmart State": "GANDHIDHAM",
                //"Procmart State PI": "GANDHIDHAM",
                //"Client Group Name": "ADANI",
                //"KamName": "Dipak Thakur"
            }

            if(tableauLinks.dashboardFilters){
                if(tableauLinks.dashboardFilters[key]){
                    options = {...options, ...tableauLinks.dashboardFilters[key]}
                }
            }

            console.log("options", options, tableauLinks)

            window.tableau && new window.tableau.Viz(indvTableauContainer, vizUrl, options);
    
            tableauApplicationContainer.appendChild(indvTableauContainer);
            tableauApplicationContainer.appendChild(tableauStyleContainer);
        })
    }

    return (
        <div>
            <div id='tableau-application' className="application" style={{ marginTop: '5px' }}>
            </div>
        </div>
    );
};

export default TableauDashboard;
